export const stackedReportSlice = set => ({
  sortByKey: 'Paid Imp',
  sortOrder: 'desc',
  disabledSources: [],
  groupingEnabled: true,
  prebidSplitMode: 'serverClient',
  // Analytics filters
  analyticsCountryFilter: null,
  analyticsDeviceFilter: null,
  analyticsBidderFilter: null,
  analyticsAttributeGroups: null,
  // Track the last report type to prevent sort/enabled metric from resetting
  // when period or selection changes. Only reset defaults when switching between
  // different report types (e.g., analytics -> demand, direct -> prebid, etc.)
  lastReportType: null,
});
